
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/guest-interviews",
      function () {
        return require("private-next-pages/guest-interviews.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/guest-interviews"])
      });
    }
  